export enum MessageRole {
  system = "system",
  user = "user",
  assistant = "assistant",
}
